import { render, staticRenderFns } from "./AppFilePreview.vue?vue&type=template&id=28721a6c&scoped=true&"
import script from "./AppFilePreview.vue?vue&type=script&lang=ts&"
export * from "./AppFilePreview.vue?vue&type=script&lang=ts&"
import style0 from "./AppFilePreview.vue?vue&type=style&index=0&id=28721a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28721a6c",
  null
  
)

export default component.exports